import { rulesValidations } from "../scripts/Validations"
import { $segments } from '@/services'
import merge from 'lodash/merge'
import readableString from './ReadableString'
import store from '@/store'
import cloneDeep from 'lodash/cloneDeep'

export const getRules = (rules,filterObj,model) =>{
    let allRules  = []
    if(typeof (rules) == 'string'){
         allRules = rules.split(',')    
    }else{
         allRules = rules
    }
    let rulesArray = []
    allRules.forEach(ele => {
        if(typeof(ele) == 'string'){
            rulesArray.push(rulesValidations[ele] ? rulesValidations[ele] : true )
        }else if(typeof(ele) == 'object'){
            for (const key in ele) {
                if(rulesValidations[key]){
                    let err = null;
                    let index = allRules.findIndex(x=>x[key+'Error'])
                    if(index != -1){
                        err = allRules[index][key + 'Error']
                    }
                    
                    let compareValue = null

                    if(typeof ele[key] == 'number')
                        compareValue = ele[key]  
                    else
                        compareValue = filterObj[ele[key]]

                    rulesArray.push((v)=>rulesValidations[key](compareValue,v,err))
                }
            }
        }
    });
    return rulesArray
}
export const executeFunctionByName = (functionName,context) =>  {
    if(typeof(functionName) == "string"){
        let namespaces = functionName.split(".");
        let func = namespaces.pop();
        for(let i = 0; i < namespaces.length; i++) {
            context = context[namespaces[i]];
        }
        return context[func];
    }
    return functionName
}

export const checkForShowMore = (ele, filter, model ,getElementType) =>{
    delete filter.optionalFilters;
    if(filter[model])
        filter.haveMoreOptions = getElementType(ele.model,ele.optionalFiltersKey)
    else
        filter.haveMoreOptions = false
    
    filter.allFilters[0].children.default.splice(1,filter.allFilters[0].children.default.length-1)
    filter.allFilters[0].childrenCount = 1;
    delete filter["filters.optional_filters.[key]"]
    
}

export const updateChildren = (ele, filter , model, getElementType, that) =>{
    if(ele.children.default){
        let children= resetChildrenData(ele.children.default[0] )
        ele.children = {
            default : []
        }
        ele.children.default.push(children) 
        if(!filter[model]){
            ele.childrenCount = typeof(ele.defaultChildrenToShow) == 'number' ? ele.defaultChildrenToShow : 0
        }else{
            ele.childrenCount = typeof(ele.ChildrenToshowOnValueChange) == 'number' ? ele.ChildrenToshowOnValueChange : 1
        }   
        findKeyInChildren(ele.children,filter,that)
    }
}

const resetChildrenData = (data=[],cloneObj=[]) => {
    data.forEach(obj => {
        let tempObj = {...obj, isRefresh:true}
        if(!tempObj.childrenApi && tempObj.children && tempObj.children.default && tempObj.children.default[0]){
            tempObj.children = {
                default : []
            }
            resetChildrenData(obj.children.default[0],tempObj.children.default)
        }else{
            tempObj.children = {}
        }
        cloneObj.push(tempObj)
    });
    return cloneObj
}

export const addChildren = (ele, filter, model ,getElementType ,that) => {
    if(filter[model]){
        let payload = {
            params:{}
        }
        if(ele.childrenApiFields && typeof ele.childrenApiFields === 'object'){
            for (let key in ele.childrenApiFields){
                let value = '';
               if(typeof ele.childrenApiFields[key] === 'object'){
                    if(ele.childrenApiFields[key].model && ele.childrenApiFields[key].model.includes('[key]')){
                        let str = updateKeyWIthParent(ele, filter.allFilters, key, true, true)
                        ele.childrenApiFields[key].model = str
                    }
                    if(ele.childrenApiFields[key].default){
                        payload.params[key] = ele.childrenApiFields[key].value
                    }else{ 
                        value = ele.childrenApiFields[key].value;
                        if(ele.childrenApiFields[key].value.includes('[key]')){
                            value = ele.model;
                        }
                        payload.params[key] =  getElementType(ele.childrenApiFields[key].model,value)
                    }
                    if(!payload.params[key]) return;
                }else{
                    value = ele.childrenApiFields[key];
                    if(ele.childrenApiFields[key].includes('[key]')){
                        let str = updateKeyWIthParent(ele, filter.allFilters, key,false,true)
                        if(str && filter[str])
                            value= str
                        else
                            value = ele.model;
                    }
                    payload.params[key] = filter[value]
                }
            }
        }
        ele.children = {}
        that.$set(ele,'childLoading',true)
        $segments.fetchSegmentsData(ele.childrenApi,payload).then(res=>{
            let child = res.data.data
            ele.children = child
            ele.childrenCount = typeof(ele.ChildrenToshowOnValueChange) == 'number' ? ele.ChildrenToshowOnValueChange : 1
            findKeyInChildren(child,filter,that)
        })
        .finally(() => {
            that.$set(ele,'childLoading',false)
          });
    }else{
        ele.children = {}
        ele.childrenCount = 0
    }
}

const findKeyInChildren = (child,filter) =>{
    if(child.default){
        child.default.forEach(ele => {
            for(let i=0;i<ele.length;i++){
                if(ele[i].model && ele[i].model.includes('[key]')&& ele[i].replaceKeyWithParent )
                {
                    let parent =  searchParentElement(ele[i].model , filter.allFilters[0].children.default)
                    if(parent){
                        updateCurrentModel(filter,parent.model,ele[i])
                        if(ele[i].rules && (typeof ele[i].rules === 'object' && Array.isArray(ele[i].rules))){
                            ele[i].rules.forEach(x=>{
                                    if(typeof x === 'object'){
                                            for( var key in x ) {
                                                if( typeof x[key] === 'string' && x[key].includes('[key]')){
                                                let keyArray = parent.model.split('.')
                                                let parentIndex = keyArray.findIndex(x=> x == 'optional_filters')
                                                let modelArray = x[key].split('.')
                                                let index = modelArray.findIndex(x => x == 'optional_filters')
                                                modelArray[index+1] = keyArray[parentIndex+1]
                                                let str = ''
                                                modelArray.forEach(element => {
                                                    str = !str ? element : str + '.' + element
                                                });
                                                x[key] = str
                                            }
                                        }
                                    }
                                }
                            )
                        }
                    }
                }
                if(ele[i].children && ele[i].children.default){
                    findKeyInChildren(ele[i].children,filter)
                }
            }
        });
    }
}

export const updateKeyWIthParent = (ele,ruleFilter,key,apiObject=true,childrenApi=false) => {
    let parent =  searchParentElement(ele.model , ruleFilter[0].children.default)
    if(parent){
        let keyArray = parent.model.split('.')
        let val = keyArray[keyArray.findIndex(x=> x == 'optional_filters')+1]
        let modelArray = ''
        if(apiObject)
            modelArray = ele[childrenApi ? 'childrenApiFields':'apiFields'][key].model.split('.')
        else
            modelArray = ele[childrenApi ? 'childrenApiFields':'apiFields'][key].split('.')

        let index = modelArray.findIndex(x => x == 'optional_filters')
        modelArray[index+1] = val
        let str = ''
        modelArray.forEach(element => {
            str = !str ? element : str + '.' + element
        });
        return str
    }
    return ''
}

export const updateOptionalFilterKeys = (filterObj , element , value='',setValue = true) =>{
    delete filterObj[element.model]
    if(!value) return;

    let val =  value 
    let tempObj = null;
    if(element.optionalFilter){
        if(typeof value == 'object'){
            tempObj = {...value}
            value = value[element.item_text]
        }
        val = value.replace(/ /g,"_");
        val = val.toLowerCase();
    }
    let modelArray = element.model.split('.')
    let index = modelArray.findIndex(x => x == 'optional_filters')
    modelArray[index+1] = val
    let str = ''
    modelArray.forEach(element => {
        str = !str ? element : str + '.' + element
    });
    
    element.model = str
    if(setValue)
        filterObj[str] = tempObj ? {'notConvertabelString' : true,...tempObj} : value
    
}

export const searchParentElement = (model, rullArray,parent,returnValue ='') => {
    let allRules = []
    if(typeof rullArray[0] === 'object' && !Array.isArray(rullArray[0]))
        allRules.push(rullArray)
    else
        allRules = rullArray

    for(let n = 0; n < allRules.length ;n ++){
        for (let i=0; i<allRules[n].length; i++){
            let rule = allRules[n][i]
            if(rule.model == model){
               return parent
            }
            else{
                if(typeof rule === 'object' && !Array.isArray(rule)){
                    if(rule.children && rule.children.default){
                        let value  = searchParentElement(model,rule.children.default,rule, returnValue) 
                        if (value) return value
                    }
                }else{
                    for(let j=0;j<rule.length;j++){
                        if(rule[j].children && rule[j].children.default){
                            let value  =  searchParentElement(model,rule[j].children.default,rule, returnValue)
                            if (value) return value
                        }
                    }
                }
            }
        }
        
    }
    return returnValue
}

export const updateCurrentModel = (filterObj,parentModel,ele) =>{
    let keyArray = parentModel.split('.')
    let index = keyArray.findIndex(x=> x == 'optional_filters')
    if(ele.model.includes('[key]')){
        if(index != -1)
            updateOptionalFilterKeys(filterObj,ele,keyArray[index+1],false)
    }
}


export const updateSegmentData = (segment,deleteId)=> {
    
    for(let i =0; i<segment.segment_rules_attributes.length; i++ ){
        let rule = segment.segment_rules_attributes[i].segment_filters_attributes;
        if(deleteId)
            delete segment.segment_rules_attributes[i].id
            
        for(let j =0; j<rule.length;j++){
            let filter = rule[j]
            delete filter.filterId;
            delete filter.filters
            if(deleteId)
                delete filter.id

            let obj = {}
            let seq = 1
            for(let [key,value] of Object.entries(filter)){
                let objKey = key.split('.')
                var tempObject = {};
                var container = tempObject;
                if(objKey.length > 1){
                    objKey.map((k, i, values) => {
                        let tempObj = {}
                        if(values.includes('optional_filters') && values.includes('name') && k == values[values.length - 2]){
                            tempObj.seq = seq
                            tempObj.name = filter[key]
                            seq++;
                        }
                       container = (container[k] = (i == values.length - 1 ? filter[key] : tempObj))
                    });
                }else{
                    obj[key] = filter[key];

                }
                obj = merge(obj,tempObject)
            }
            obj.filters.stringData = getReadableString(filter)
            delete segment.segment_rules_attributes[i].aiQuery
            delete segment.segment_rules_attributes[i].aiUsed
            
            if(obj.filters.optional_filters){
                for(let [key,value] of Object.entries(obj.filters.optional_filters)){
                    if(value.name)
                        continue;
                    else{
                        let str = key.split('_').join(' ');
                        const words = str.split(" ");
                        for (let i = 0; i < words.length; i++) {
                            words[i] = words[i][0].toUpperCase() + words[i].substr(1);
                        }
                        value.name = words.join(" ")
                    }
                }
            }
            delete obj.allFilters;
            delete obj.haveMoreOptions
            delete obj.optionalFilters
            rule[j] = obj;
        }
    }
    return segment;
}
export const convertObjectToString = (obj) =>{
    function walk(into, obj, prefix = []) {
        Object.entries(obj).forEach(([key, val]) => {
          if (typeof val === "object" && !Array.isArray(val) && !val.notConvertabelString){
            walk(into, val, [...prefix, key]);
          } 
          else {
            into[[...prefix, key].join(".")] = val;
          }
        });
      }
      const out = {};
      walk(out, obj);
      return {...out};
}

export const sortOptionalFilters = (obj,newObj ={}) =>{
    let index;
    let name = ''
    let objValue= {}
    for(let [key,value] of Object.entries(obj)){
        if(!obj[key].name){
            delete obj[key]
            continue;
        }
        if(!index || (index && value.seq < index)){
            index = value.seq
            name = key
            objValue = value
            delete objValue.seq
        }  
        
    }
    if(name)
        newObj[name] = objValue
    delete obj[name]
    if(Object.keys(obj).length)
        sortOptionalFilters(obj,newObj)
    return newObj;
}

export const getReadableString = (filter) =>{
   
    let allFilter = filter.allFilters[0].children
    let positionedArrary = [getElementTypeAndValue(filter.allFilters[0],filter)]
    let readAbleArray = []
    allFilter.default.forEach((element,index) => {
        if(index>0)
            positionedArrary = []
        readAbleArray.push(getStringFromFilter(filter,element,positionedArrary,index))
    });
    
    if(filter.criteria == 'Relational Tables'){
        readAbleArray[1].forEach(x=>{
            readAbleArray[0].push(x)
        })
        readAbleArray.splice(1,1)
    }
    return readAbleArray
}

export const checkApiCall = (rule,filterObject,formValid = false)=>{
    if(rule.default){
        for(let i=0 ;i< rule.default.length ; i++ ){
            for(let j=0; j <rule.default[i].length; j++){
                if(rule.default[i][j].loading || rule.default[i][j].childLoading || 
                    (rule.default[i][j].type == 'tree' && 
                        (!filterObject[rule.default[i][j].model] || filterObject[rule.default[i][j].model].length == 0)
                    )
                ){
                     return false
                }else if(rule.default[i][j].children && rule.default[i][j].children.default){
                    formValid = checkApiCall(rule.default[i][j].children,filterObject,formValid)  
                    if(!formValid)
                        return formValid
                }
                else {
                    formValid = true
                }
            }
        }
    }
    return formValid
}

export const findGenrateAIData = (rule) =>{
    for(let i=0 ; i< rule.length; i++){
        let allFilter = cloneDeep(rule[i].allFilters);
        delete rule[i].isHidden
        delete rule[i].aiGenrated
        delete rule[i].savePrompt
        let newModel = checkAINestedObj(allFilter,rule[i])
        newModel.allFilters = allFilter
        if(rule[i].id)
            newModel.id = rule[i].id;
        if(rule[i].segment_id)
            newModel.segment_id = rule[i].segment_id;
        if(rule[i].segment_rule_id)
            newModel.segment_rule_id = rule[i].segment_rule_id;
        if(rule[i].account_id)
            newModel.account_id = rule[i].account_id;
        rule[i] = cloneDeep(newModel)
    }
    return rule;
}

const checkAINestedObj = (allFilter,ruleObj,newObj={}) =>{
    allFilter.forEach(filter=>{
        if(filter.children && filter.children.default){
            filter.children.default.forEach(el=>{
                checkAINestedObj(el,ruleObj,newObj)
            })
        }
        if(filter.model)
            newObj[filter.model] = ruleObj[filter.model]
    })
   return newObj
}


const getStringFromFilter = (filterObj, filter, positionedArrary=[],index) =>{
        filter.forEach(el => {
            if(!el.hideFromReadableString){
                let text = ''
                if(el.readableData){
                    if(el.readableData.position && typeof el.readableData.position == 'number'){
                        text = positionedArrary[el.readableData.position - 1] ? positionedArrary[el.readableData.position - 1] : '' 
                    }
                    
                    if(text) {
                        text = text.trim()
                        text += " "
                    }

                    if(el.readableData.preText)
                    text += el.readableData.preText

                    if(text) {
                        text = text.trim()
                        text += " "
                    }

                    text += getElementTypeAndValue(el,filterObj)

                    if(el.readableData.postText)
                    text += " "+el.readableData.postText

                    var html = text;
                    var div = document.createElement("div");
                    div.innerHTML = html;
                    var tempText = div.textContent || div.innerText || "";
                
                    if(el.readableData.position){
                        if(tempText.length > 65 && index == 0){
                            positionedArrary[el.readableData.position -1] = {text:text}
                        }else{
                            positionedArrary[el.readableData.position -1] = text
                        }
                    }else{
                        if(tempText.length > 65 && index == 0){
                            positionedArrary.push({text:text})
                        }else{
                            positionedArrary.push(text)
                        }
                    }
                    return getChildrenReadable(filterObj,el, positionedArrary,index)
                }else{
                    if(text) {
                        text = text.trim()
                        text += " "
                    }
                    text += getElementTypeAndValue(el,filterObj)

                    var html = text;
                    var div = document.createElement("div");
                    div.innerHTML = html;
                    var tempText = div.textContent || div.innerText || "";

                    if(tempText.length > 65){
                        positionedArrary.push({text:text})
                    }else{
                        positionedArrary.push(text)
                    }
                    return getChildrenReadable(filterObj,el, positionedArrary,index)
                }
            }else{
                return getChildrenReadable(filterObj,el, positionedArrary,index)
            }
        });

    return positionedArrary;
}
const getChildrenReadable = (filterObj,el, positionedArrary,index)=>{
    let arr = []
    if(el.children && el.children.default){
        el.children.default.forEach(element => {
            arr.push(getStringFromFilter(filterObj,element, positionedArrary,index))
        });
    }
    return arr;
}
const getElementTypeAndValue = (ele,filterObj) =>{
    if(ele.type == "dropdown"){
        if(ele.readableData){
            if(ele.readableData.formatFunction && typeof ele.readableData.formatFunction == 'string'){
                const func =  executeFunctionByName(ele.readableData.formatFunction,readableString)
                return func(filterObj[ele.model], ele,ele.readableData.readableKey);
            }
            if(ele.readableData && (ele.readableData.showChips || ele.readableData.clickableLink)){
                return getclickableChips(filterObj[ele.model],ele,ele.readableData.showChips , ele.readableData.clickableLink)
            }
        }
        let selectedValue = ''
        if(filterObj[ele.model])
            selectedValue = filterObj[ele.model][ele.item_value] ? filterObj[ele.model][ele.item_value]
                            : filterObj[ele.model][ele.item_text] ? filterObj[ele.model][ele.item_text]
                            : filterObj[ele.model] 
        
        let selectedIndex = ele.items.findIndex(x=>{
            if(x[ele.item_value]){
               return x[ele.item_value] == selectedValue
            }else{
               return x == selectedValue
            }
        })
        if(selectedIndex != -1){
            let val = ele.items[selectedIndex][ele.item_text] ? ele.items[selectedIndex][ele.item_text] 
                    : ele.items[selectedIndex][ele.item_value] ? ele.items[selectedIndex][ele.item_value] 
                    : ele.items[selectedIndex]
            let excludingVals = ['Device Type','Mail Privacy Protection','Campaign Converted','Campaigns Sent','Campaigns Received','Campaigns Clicked','Campaigns Opened','Campaign','Site Page','Coupon Bank']
            if(excludingVals.includes(val)&& ('optionalFilter' in ele && ele['optionalFilter']))
                return '';
            return val;
        }
        return '';
    }
    if(ele.type == "textField" || ele.type == "calendar"){
        if(ele.rules.includes('number'))
            return filterObj[ele.model] ? filterObj[ele.model] : 0
        if(ele.readableData){
            if(ele.readableData.formatFunction && typeof ele.readableData.formatFunction == 'string'){
                const func =  executeFunctionByName(ele.readableData.formatFunction,readableString)
                return func(filterObj[ele.readableData.model] ,filterObj[ele.model]);
            }
        }
        if(filterObj[ele.model])
            return '"'+ filterObj[ele.model]+ '"'
        return ""
    }
    if(ele.type == "text"){
        return ele.text
    }
    if(ele.type == "autocomplete" || ele.type == "tree"){
        let string = ''
        for(let i=0; i < (filterObj[ele.model].length > 2 ? 2 : filterObj[ele.model].length); i++){
            if(ele.readableData && (ele.readableData.showChips || ele.readableData.clickableLink)){
                string += getclickableChips(filterObj[ele.model][i],ele,ele.readableData.showChips , ele.readableData.clickableLink)
            }else{
                string +=  filterObj[ele.model][i][ele.item_text]
                if(i<1)
                    string += ','
                else 
                    string += ' '
            }
        }
        if(filterObj[ele.model].length > 2){
            string += `{{spanTag}} ${filterObj[ele.model].length - 2} {{spanTagEnd}}`
         }
         return string
 
     }
     if(ele.readableData){
         if(ele.readableData.formatFunction && typeof ele.readableData.formatFunction == 'string'){
             const func =  executeFunctionByName(ele.readableData.formatFunction,readableString)
             return func(filterObj[ele.model]);
         }
     }
 }
 
 const getclickableChips = (element,ele,chips = false, link = false) =>{  
     if(chips && !link){
         return `{{chipNotClickable}}${element[ele.item_text]}{{anchorTagClose}}`
     }
     if(link){
        if(element){
            link = link.replace('/accounts/:accountId','')
            if(element[ele.item_value] && typeof element[ele.item_value] == 'string')
                return element[ele.item_text] ;

            link = link.replace(':id',element[[ele.item_value ? ele.item_value : ele.item_text ]])
            if(chips)
                return `{{chipClickable}}##${link}##}}${element[ele.item_text]}{{anchorTagClose}}`
            else
                return `{{clickableLink}}##${link}##${element[ele.item_text]}{{anchorTagClose}}`
        }
        return '';
    }
 }
 
const getStringTag = () =>{
     return {
         '{{spanTag}}' : "<span style='font-size:12px;margin-left:7px;color:gray;'> and",
         '{{spanTagEnd}}' : " more</span>",
         '{{chipNotClickable}}': '<a style="color:#000!important;cursor:auto;background:#cbdae8;padding-top:7px;padding-bottom:7px;padding-left:15px;padding-right:15px;border-radius:53px;text-decoration:none;margin-right:5px;">',
         '{{anchorTagClose}}' : '</a>',
         '{{chipClickable}}' : '<a style="color:#000!important;text-decoration:none;color:rgb(0,9,178)!important;background:#cbdae8;padding-top:7px;padding-bottom:7px;padding-left:15px;padding-right:15px;border-radius:53px;text-transform:capitalize;text-decoration:none;margin-right:5px;" href={{clickableURL}} target="_blank">',
         '{{clickableLink}}' : '<a style="text-decoration:none;color:rgb(0,9,178)!important;" href={{clickableURL}} target="_blank">'
     }
 }
const replaceTagFromString = htmlString =>{
    htmlString = htmlString.text ? htmlString.text : htmlString
    const tagRegex =/{{(.*?)}}/g;
    const linkRegex = /##(.*?)##/g
    const foundTags = htmlString.match(tagRegex);
    const linkTags = htmlString.match(linkRegex);
    if(foundTags && foundTags.length){
        for(let i=0;i<foundTags.length;i++){
            htmlString = htmlString.replace(foundTags[i], getStringTag()[foundTags[i]])
            if(linkTags){
                let link = linkTags.map(tag => tag.replace(/##|##/g, '').trim());
                link = "/accounts/"+store.getters['auth/account'].id+link
                htmlString = htmlString.replace(linkTags,'')
                htmlString = htmlString.replace('{{clickableURL}}', link)
            }
        }
    }
    return htmlString;
}

 export const replaceReadableTags = data =>{
    return data.map(item=>{
        return item.map(str=>{
            return replaceTagFromString(str)
        })
    })
 }